/**
 * Proof of Grind – verwachte leverdatum.
 * vandaag + min..max werkdagen (ma–vr). Na de besteltijd (cutoff) telt vandaag niet mee:
 * dan begint het tellen vanaf de volgende werkdag.
 */
const DAGEN = ['zo', 'ma', 'di', 'wo', 'do', 'vr', 'za'];
const MAANDEN = ['jan', 'feb', 'mrt', 'apr', 'mei', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'];

function isWerkdag(d) {
  const w = d.getDay();
  return w !== 0 && w !== 6;
}

function addWerkdagen(start, n) {
  const d = new Date(start);
  let left = n;
  while (left > 0) {
    d.setDate(d.getDate() + 1);
    if (isWerkdag(d)) left -= 1;
  }
  return d;
}

function format(d) {
  return `${DAGEN[d.getDay()]} ${d.getDate()} ${MAANDEN[d.getMonth()]}`;
}

export function berekenLevering(min, max, cutoffHour, now = new Date()) {
  // Startpunt: vandaag als het nog vóór de besteltijd is én een werkdag; anders de volgende werkdag.
  const start = new Date(now);
  start.setHours(0, 0, 0, 0);
  const naCutoff = now.getHours() >= cutoffHour;
  if (naCutoff || !isWerkdag(start)) {
    do {
      start.setDate(start.getDate() + 1);
    } while (!isWerkdag(start));
    // Bestelling wordt pas de volgende werkdag verwerkt; die dag zelf telt als dag 0.
  }
  return { from: addWerkdagen(start, min), to: addWerkdagen(start, max) };
}

class PogDeliveryEstimate extends HTMLElement {
  connectedCallback() {
    this.render();
    // Na een morph (variant-/productwissel) staat de fallbacktekst er weer: opnieuw berekenen.
    this.observer = new MutationObserver(() => {
      const target = this.querySelector('[ref="dates"]');
      if (target && !target.dataset.pogRendered) this.render();
    });
    this.observer.observe(this, { childList: true, subtree: true, characterData: true });
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }

  render() {
    const min = parseInt(this.dataset.min, 10) || 2;
    const max = Math.max(min, parseInt(this.dataset.max, 10) || 4);
    const cutoff = parseInt(this.dataset.cutoff, 10);
    const target = this.querySelector('[ref="dates"]');
    if (!target) return;
    try {
      const { from, to } = berekenLevering(min, max, Number.isFinite(cutoff) ? cutoff : 15);
      target.textContent = `${format(from)} – ${format(to)}`;
      target.dataset.pogRendered = '1';
    } catch (e) {
      // laat de fallback-tekst staan
    }
  }
}

if (!customElements.get('pog-delivery-estimate')) {
  customElements.define('pog-delivery-estimate', PogDeliveryEstimate);
}
